module.exports = __webpack_public_path__ + "static/media/a19.bed7b63f.pdf";